import React from 'react';
import InquiryForm from '../common/InquiryForm';

const HeroSection: React.FC = () => {
  return (
    <div 
      className="relative bg-cover bg-center pt-28 pb-16 md:pt-36 md:pb-24" 
      style={{ 
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.7)), url(https://images.pexels.com/photos/3938023/pexels-photo-3938023.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1)` 
      }}
    >
      <div className="container-custom">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
          <div className="text-white">
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-4 text-white leading-tight">
              Your Gateway to a Successful <span className="text-secondary-500">Veterinary Career</span>
            </h1>
            <p className="text-lg md:text-xl text-gray-200 mb-8">
              Expert guidance for BVSc admissions across top veterinary colleges in India. 
              Start your journey to become a veterinary professional today.
            </p>
            <div className="hidden md:flex flex-wrap gap-4">
              <a 
                href="tel:+917389205299" 
                className="btn btn-secondary text-primary-800 font-semibold"
              >
                Call Now
              </a>
              <a 
                href="#services-section" 
                className="btn btn-outline border-white text-white hover:bg-white hover:text-primary-700"
              >
                Our Services
              </a>
            </div>
          </div>
          
          <div className="bg-white rounded-lg shadow-lg p-6 md:p-8">
            <h3 className="text-xl font-semibold text-primary-700 mb-4">
              Begin Your Veterinary Journey
            </h3>
            <InquiryForm />
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeroSection;